import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../utils/hooks/useMutationWithError";
import { useCreatePhoneVerificationMutation } from "./__generated__/useCreatePhoneVerificationMutation.graphql";

export const useCreatePhoneVerification = () => {
  const [createVerification, isCreating] =
    useMutationWithError<useCreatePhoneVerificationMutation>(
      useCreatePhoneVerificationMutationString
    );

  const createPhoneVerification = (
    phoneNumber: string,
    onCompleteHandler: () => void
  ) => {
    createVerification({
      variables: { input: { phoneNumber } },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleteHandler();
        }
      },
    });
  };
  return [createPhoneVerification, isCreating] as const;
};

export const useCreatePhoneVerificationMutationString = graphql`
  mutation useCreatePhoneVerificationMutation(
    $input: CreatePhoneVerificationInput!
  ) {
    responsePayload: createPhoneVerification(input: $input) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
